const actions = {
  async getUserAuth ({ commit }, activeAccountId) {
    const response = await window.axios.get('/users/profile')
    const activeAccount = response.data.accounts.filter((account) => {
      return account.id === parseInt(activeAccountId)
    })[0]

    commit('SHOW_LOWER_BID_ERROR', JSON.parse(JSON.stringify(response.data)))
    commit('USER_LOGGED_IN', JSON.parse(JSON.stringify(response.data)))
    commit('SET_ACTIVE_ACCOUNT', activeAccount)
    commit('SHOW_NOTIFICATION_BAR', JSON.parse(JSON.stringify(response.data)))
  },
  async logout ({ commit }) {
    await window.axios.post('/logout')
    commit('LOGOUT')
    localStorage.clear()
    document.cookie.split(';').forEach(function (c) { document.cookie = c.replace(/^ +/, '').replace(/=.*/, `=;expires=${  new Date().toUTCString()  };path=/`) })
  },
  async login ({ commit }, userCredentials) {
    const response = await window.axios.post('/login', userCredentials)
    commit('USER_LOGGED_IN', JSON.parse(JSON.stringify(response.data)))
    commit('SET_ACTIVE_ACCOUNT', response.data.accounts[0])

    localStorage.setItem('activeAccountId', response.data.accounts[0]['id'] || null)
  },
  async createAccount ({ commit }, account) {
    const { data: createdAccount } = await window.axios.post('/accounts', account)
    commit('SET_ACTIVE_ACCOUNT', createdAccount)

    localStorage.setItem('activeAccountId', createdAccount['id'])
  },
  async register (vuex, payload) {
    payload = {
      ...payload,
      account_type: payload.account_type.value,
      budget: payload.budget.value,
      communication_method: payload.communication_method.value,
      industry: payload.industry.value
    }

    const res = await window.axios.post('/register', payload)

    return res.data
  },
  async sendForgetPasswordEmail (vuex, payload) {
    await window.axios.post('/password/email', payload)
  },
  async sendResetPasswordEmail (vuex, payload) {
    await window.axios.post('/password/reset', payload)
  },
  async sendVerificationEmail (vuex, payload) {
    await window.axios.post('/email/resend', payload)
  },
  async updateProfile ({ commit }, payload) {
    const { data: updatedUser } = await window.axios.post('/users/profile', payload)
    commit('USER_UPDATED', updatedUser)
  },
  async updateProfileWithAvatar ({ commit }, payload) {
    const { data: updatedUser } = await window.axios.post('/users/profile', payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    commit('USER_UPDATED', updatedUser)
  }
}

export default actions
